export default __webpack_public_path__ + "static/media/ABCArizonaFlare-Bold.b76463f2.otf";